<template>
    <div>
        <h3 class="title_header">{{ companyName }}-员工管理({{ productName }})</h3>


        <div class="from_header">
            <div class="seache_left">

            </div>
            <div class="seache_right">
                <el-button type="primary" @click="dialogVisible = true" style="margin: 0px 0px 0px 10px">新增</el-button>
            </div>
        </div>

        <el-table
                ref="singleTable"
                :data="tableData"
                highlight-current-row
                @selection-change="handleSelectionChange"
                style="width: 100%;align:center;margin-top: 5px">
            <el-table-column type="selection"></el-table-column>
            <el-table-column
                    type="index"
                    width="50">
            </el-table-column>
            <el-table-column
                    prop="realName"
                    label="姓名">
            </el-table-column>


            <el-table-column
                    prop="bindMobile"
                    label="手机号">
            </el-table-column>

            <el-table-column
                    prop="bindMail"
                    label="邮箱">
            </el-table-column>
            <el-table-column label="员工类型">
                <template slot-scope="scope">
                    {{ scope.row.employeeType == 1 ? '管理员' : '普通用户' }}
                </template>
            </el-table-column>
            <el-table-column label="创建类型">
                <template slot-scope="scope">
                    {{ scope.row.createType == 1 ? '平台创建' : '企业创建' }}
                </template>
            </el-table-column>
            <el-table-column label="变更时间">
                <template slot-scope="scope">
                    {{ dateFormat(scope.row.updateDate) }}
                </template>
            </el-table-column>
            <el-table-column
                    prop="updateUserName"
                    label="变更人">
            </el-table-column>


            <el-table-column
                    label="操作" header-align="center">
                <template slot-scope="scope">
                    <el-button class="btn-text-edit" size="mini" type="text" @click="edit(scope.row)">编辑</el-button>
                    <el-button class="btn-text-edit" size="mini"
                               type="text" @click="deleteEmployee(scope.row)">删除
                    </el-button>
                    <el-button class="btn-text-edit" size="mini"
                               type="text" @click="showResetPwd(scope.row)">重置密码
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination class="pagination_bottom"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="parseInt(searchForm.pageNum)"
                       :total="searchForm.total"
                       :page-size="searchForm.pageSize"
                       :page-sizes="[10, 20, 50,100, 200]"
                       layout="total, sizes, prev, pager, next, jumper"
        >
        </el-pagination>

        <!--新增或编辑-->
        <el-dialog :title="isAdd?'新增':'修改'" :visible.sync="dialogVisible" :before-close="dialogCancel" width="500px">
            <el-form :model="dialogData" :rules="rules" ref="addRef">
                <el-form-item label="姓名:" :label-width="formLabelWidth" prop="realName">
                    <el-input v-model="dialogData.realName" autocomplete="off" style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="手机号:" :label-width="formLabelWidth" prop="bindMobile">
                    <el-input v-model="dialogData.bindMobile" autocomplete="off" style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="邮箱:" :label-width="formLabelWidth" prop="bindMail">
                    <el-input v-model="dialogData.bindMail" autocomplete="off" style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="用户类型:" :label-width="formLabelWidth" style="text-align: left;" prop="employeeType">
                    <el-select v-model="dialogData.employeeType" placeholder="用户类型" clearable style="width: 300px">
                        <el-option label="超管" :value="1">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogCancel()">取 消</el-button>
                <el-button type="primary" @click="dialogAffirm()">确 定</el-button>
            </div>
        </el-dialog>


        <!--重置密码弹窗-->
        <el-dialog title="提示" :visible.sync="dialogDeleteVisible" width="30%" :before-close="dialogDeleteCancel">
            <span>密码重置后为手机号后6为，确认重置以下账户密码？</span>
            <div>{{ resetPwdData.realName }} {{ resetPwdData.bindMobile }}</div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogDeleteCancel()">取 消</el-button>
                <el-button type="primary" @click="resetPwd()">确 定</el-button>
            </div>
        </el-dialog>

    </div>


</template>

<script>


    export default {
        data() {
            return {

                searchForm: {
                    pageNum: 1,
                    pageSize: 10,
                    total: null,
                    companyPid: 0,
                },
                tableData: [],

                companyName: "",
                productName: "",

                isAdd: true,
                dialogVisible: false,
                dialogData: {},
                rules: {
                    realName: [
                        {required: true, message: "请输入姓名", trigger: "blur"}
                    ],
                    bindMobile: [
                        {required: true, message: "请输入手机号", trigger: "blur"}
                    ],
                    bindMail: [
                        {required: true, message: "请输入邮箱", trigger: "blur"}
                    ],
                    employeeType: [
                        {required: true, message: "请选择用户类型", trigger: "blur"}
                    ],
                },
                formLabelWidth: '110px',

                //选中的员工ID
                selectPidList: [],

                dialogDeleteVisible: false,
                resetPwdData: {},

            }
        },
        mounted() {
            this.searchForm.companyPid = this.$route.query.pid;
            this.companyName = this.$route.query.companyName;
            this.productName = this.$route.query.productName;
            if (this.searchForm.companyPid < 0) {
                this.$router.push({name: "companyList"});
            }
            this.init();
        },
        methods: {
            init() {
                this.getCompanyEmployeeList();
            },
            /**
             * 获取公司员工列表
             * @param val 当前页
             */
            getCompanyEmployeeList(val) {
                if (val == 1) this.searchForm.page = 1;
                this.$post(this.$url.员工列表, this.searchForm).then((res) => {
                    this.tableData = res.list;
                    this.searchForm.pageNum = parseInt(res.pageNum);
                    this.searchForm.pageSize = parseInt(res.pageSize);
                    this.searchForm.total = parseInt(res.total);
                }).catch((err) => {
                    Promise.reject(err);
                });
            },

            //编辑或添加
            dialogAffirm() {
                this.$refs["addRef"].validate((valid) => {
                    if (valid) {
                        let url;
                        if (this.isAdd) {
                            url = this.$url.新增公司员工;
                        } else {
                            url = this.$url.编辑公司员工;
                        }
                        this.dialogData.companyPid = this.searchForm.companyPid;
                        this.$post(url, this.dialogData, true).then((res) => {
                            this.$message.success("成功");
                            this.dialogCancel();
                            this.getCompanyEmployeeList(1);
                        }).catch((err) => {
                            Promise.reject(err);
                        });
                    } else {
                        return false;
                    }
                });
            },

            //打开编辑弹窗
            edit(row) {
                this.isAdd = false;
                this.dialogData = row;
                this.dialogVisible = true;
            },

            //修改密码弹窗关闭事件
            dialogDeleteCancel() {
                this.dialogDeleteVisible = false;
            },

            //修改密码弹窗
            showResetPwd(row) {
                this.dialogDeleteVisible = true;
                this.resetPwdData = row;
            },
            resetPwd() {
                this.$post(this.$url.修改员工密码, {pidList: [this.resetPwdData.pid]}, true).then((res) => {
                    this.$message.success("成功");
                    this.dialogDeleteCancel();
                    this.getCompanyEmployeeList(1);
                }).catch((err) => {
                    Promise.reject(err);
                });
            },

            /**
             * 删除公司员工
             * @param pid 公司员工ID
             */
            deleteEmployee(row) {
                this.$confirm('是否删除【' + row.realName + "】？", '确认信息', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '确认',
                    cancelButtonText: '返回'
                }).then(() => {
                    this.$post(this.$url.删除公司员工, {pid: row.pid}, true).then((res) => {
                        this.getCompanyEmployeeList(1);
                    }).catch((err) => {
                        Promise.reject(err);
                    });
                }).catch(action => {
                });
            },

            /***
             * 表格行选中或取消触发事件
             * @param val 选中的对象
             */
            handleSelectionChange(val) {
                this.selectPidList = [];
                for (const item of val) {
                    this.selectPidList.push(item.pid);
                }
            },

            //管理弹窗时生效
            dialogCancel() {
                this.$refs["addRef"].resetFields();
                this.dialogVisible = false;
                this.dialogTitle = true;
                this.dialogData = {}
            },

            handleCurrentChange(val) {
                this.searchForm.pageNum = val;
                this.getCompanyList();
            },
            handleSizeChange(val) {
                this.searchForm.pageSize = val;
                this.getCompanyList();
            },


        }

    }
</script>

<style scoped lang="less">
    .title_header {
        text-align: left;
        padding: 20px 20px 10px 20px;
        background-color: #FFFFFF;
        margin-bottom: 3px;
    }

    .pagination_bottom {
        text-align: right;
        background-color: #FFFFFF;
        padding: 22px 20px;

    }

    .from_header {
        background-color: #FFFFFF;
        width: 100%;
        height: 60px;
        line-height: 60px;
        display: -webkit-flex;
        display: flex;
        -webkit-align-items: center;
        align-items: center;


        .seache_left {
            width: 80%;
            height: 100%;
            display: inline-block;

            .seache_item {
                width: 260px;
                display: inline-block;
                margin-right: 20px;

                .label {
                    display: inline-block;
                    width: 35%;
                    text-align: right;
                }

                .search_input {
                    display: inline-block;
                    width: 65%;
                }
            }

        }

        .seache_right {
            width: 16%;
            height: 100%;
            display: inline-block;
            text-align: right;
        }

    }
</style>
